import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/navigation-item/navigation-item.js';
      import {ObcNavigationMenuVariant} from '@oicl/openbridge-webcomponents/dist/components/navigation-menu/navigation-menu.js';

      export interface Props {
     label?: string;
     href?: string | undefined;
     checked?: boolean;
     variant?: ObcNavigationMenuVariant;
     group?: boolean;
     groupSelected?: boolean;
     hasIcon?: boolean;
     hasTrailingIcon?: boolean
   }

      
  
      export type {ObcNavigationMenuVariant} from '@oicl/openbridge-webcomponents/dist/components/navigation-menu/navigation-menu.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcNavigationItem',
  props: {
    label: {},
    href: {},
    checked: { type: Boolean },
    variant: {},
    group: { type: Boolean },
    groupSelected: { type: Boolean },
    hasIcon: { type: Boolean },
    hasTrailingIcon: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onClick: (event: CustomEvent<void>) => emit('click', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-navigation-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})